import { render, staticRenderFns } from "./ReturnBackFitting.vue?vue&type=template&id=5c9decb2&scoped=true"
import script from "./ReturnBackFitting.vue?vue&type=script&lang=js"
export * from "./ReturnBackFitting.vue?vue&type=script&lang=js"
import style0 from "./ReturnBackFitting.vue?vue&type=style&index=0&id=5c9decb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9decb2",
  null
  
)

export default component.exports